import React from "react";
import CheckBox from "./CheckBox";

const Checkboxes = ({
  field,
  form,
  onChange,
  checked,
  options,
  checkedList,
  className,
}) => {
  return (
    <div className="component-checkbox-wrap">
      {options &&
        options.list.map(({ label, value }, idx) => (
          <CheckBox
            className={className}
            key={idx}
            field={field}
            form={form}
            checked={checked || (checkedList && checkedList.includes(value)) || !!form[value]}
            onChange={onChange}
            label={label}
            value={value}
            idx={idx}
          />
        ))}
    </div>
  );
};
export default Checkboxes;
